import { Component, Input, EventEmitter, Output } from '@angular/core';

import { SystemMessageService } from '../../../../core/system-message/system-message-service';
import { TableComponent } from '../../table.component';
import { param } from '../../../http-params';
import { AlertModalService } from '../../../../services/alert-modal.service';

@Component({
    selector: 'pcg-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
    standalone: false
})
export class DeleteButtonComponent<T> {

	@Input() url!: string; // URL to send delete request to
	@Input() id!: string; // The id of the record to delete
	@Input() confirmMessage = 'Are you sure you want to delete this?'; // Confirmation message
	@Input() table!: TableComponent<T>; // Table for ajax reload
	@Output() delete = new EventEmitter<any>(); // Can be used to trigger a custom function on delete
	
	constructor(
		private ms: SystemMessageService
		, private alertModalService: AlertModalService
	) {}

	deleteRecord() {
		if (!this.confirmMessage) { this.executeDelete(); } 
        else {
			this.alertModalService.openAlert(
				this.confirmMessage
                , () => this.executeDelete() // Confirm callback
			);
		}
	}
	
	private executeDelete(): void {
		const idQueryStr =
			typeof this.id === 'string' || typeof this.id === 'number'
				? 'id=' + encodeURIComponent(this.id)
				: param(this.id);
	
		this.ms.getHttpObservable(this, this.url + '?' + idQueryStr).subscribe(obj => {
            this.delete.emit(obj);
            if (this.table) { this.table.ajaxReload(); }
        });
	}
}
